import '../styles/scss/theme.scss';

import { Christmas } from './christmas.js';
import { Halloween } from './halloween.js';
/* ------------------------------- */

// console.log('ThemeJS loaded');
const LOGO_STATES = {
    NORMAL: 0,
    CLOSE: 1,
    MENU: 2
};

const consoleStyles = [
    'background: #a54230'
    , 'border: 1px solid #3E0E02'
    , 'color: white'
    , 'display: block'
    , 'text-shadow: 0 1px 0 rgba(0, 0, 0, 0.3)'
	, 'padding: 2em'
    , 'line-height: 40px'
    , 'text-align: center'
    , 'font-weight: bold'
].join(';');

var logoManager;
let lastScrollPos = window.scrollY;
let logoState = LOGO_STATES.NORMAL;

// Document Ready, most of your code should be put in here
$(function () {
	const thisYear = new Date().getFullYear();
    if(checkBetweenDates({start: `11/26/${thisYear}`, end: `12/30/${thisYear}`})) {
        Christmas.letItSnow();
    }
    if(checkBetweenDates({start: `10/06/${thisYear}`, end: `11/1/${thisYear}`}) ) {
        Halloween.letTheHauntingBegin();
    }
	// console.log('DOM is loaded');
	if ( window.location.pathname.includes('/team')) {
    	new Konami('/team?dungeon');
	}

    //clean this up!
    // flip on page load
    // if (!document.cookie.match(/^(.*;)?\s*NotFirstTime\s*=\s*[^;]+(.*)?$/)) {
	if (!window.localStorage.getItem('NotFirstTime') ){
        setTimeout(() => {
            $('.menu-button.ferguson-logo .logo-container').removeClass('logoSlideUp');
            // logoState = LOGO_STATES.NORMAL;
        }, 500);
       window.localStorage.setItem('NotFirstTime', true);
    } else {
        $('.menu-button.ferguson-logo .logo-container').removeClass('logoSlideUp');
    }

	if (window.location.pathname === "/") {
		animateHeaderLogo();
	}

	if (window.location.pathname.includes('level')) {
    	handleBlogAjax();
	}
    handleLightboxVideo();
    // initLandscapeModal();
    //create debounced scrollHandler
    
    //register event
    jQuery(window).on('scroll', debouncedScrollHandler);

    $('#off-canvas').on('opened.zf.offcanvas', function(event) {
        $('.menu-button.ferguson-logo').addClass('nav-open');
        if ($('.logo-container').hasClass('logoIsFlipped')) {
            $('.menu-button.ferguson-logo .logo-container').removeClass('logoIsFlipped');
            setTimeout(() => {
                $('.logo.front').addClass('logoToX');
                $('.logo.front').removeClass('logoToFA');
                setTimeout(() => {
                    $('.logo.front').addClass('logoXStay');
                    $('.logo.front').removeClass('logoToX');
                }, 500);
            }, 500);
        } else {
            $('.logo.front').addClass('logoToX');
            $('.logo.front').removeClass('logoToFA');
            setTimeout(() => {
                $('.logo.front').addClass('logoXStay');
                $('.logo.front').removeClass('logoToX');
            }, 500);
        }
        logoState = LOGO_STATES.CLOSE;
    });
    $('#off-canvas').on('closed.zf.offcanvas', function(event) {
        $('.menu-button.ferguson-logo').removeClass('nav-open');
        $('.logo.front').addClass('logoToFA');
        $('.logo.front').removeClass('logoToX');
        setTimeout(() => {
            $('.logo.front').removeClass('logoXStay');
            $('.logo.front').removeClass('logoToFA');
        }, 500);
        logoState = LOGO_STATES.NORMAL;
    });

    // $('.menu-button.ferguson-logo').on('mouseover', function(event) {
    //     if (!$(event.target).hasClass('nav-open')) {
    //         // $('.off-canvas').addClass('hovered-off-canvas');
    //         // $('.js-off-canvas-overlay').addClass('is-visible lop');
            
    //     }
    // });
    // $('.menu-button.ferguson-logo').on('mouseout', function(event) {
    //     if (!$(event.target).hasClass('nav-open')) {
    //         // $('.off-canvas').removeClass('hovered-off-canvas');
    //         // $('.js-off-canvas-overlay').removeClass('is-visible lop');
    //     }
    // });

//team?


	if ($('.page-id-5880').length) {
		$(".filter-nav-item").click(function () {
            var el = $(this);
            triggerTeamFilter(el.attr('data-filter'));
		});
        
		$(".mobile-filter").on("change", function () {
            var el = $(this);
            triggerTeamFilter(el.val());
		});

		$(".panel").click(function (e) {
			let el = $(this);

			if (el.hasClass("low-opacity")) {
				return;
			}
			if (!el.hasClass("expanded")) {
				e.stopPropagation();
				let expanded = $(".panel.expanded");
				closePanels(expanded);

				dataLayer.push({
					'name': el.attr("data-name"),
					'event': 'Profile Click'
				});
				expandPanels(el);

				$(document).one('click', function () {
					closePanels(el);
				})
			}
        });
	}

	if (window.location.pathname.includes("/services")) {
        //???
        if (!window.location.hash) {$('.tabs-title.strategy-creative, .tabs-panel.strategy-creative').addClass('is-active')};
        
        // hack for foundation tabs animation 
        $(document).on('change.zf.tabs', function(e) {
            var activeTab =   $(e.target).find('.is-active a').attr('href');
            // console.log($($(e.target).find('.is-active a').attr('href')));
            $(activeTab).css('display', 'none').fadeIn();

            $(document).scrollTop($(activeTab).offset().top - 200);
        });

        //easter egg
        //select git in digital
        $('.page-title').on('mouseup', (e)=>{
            digitalEasterEgg();
        });
        $(document).on('keyup', (e)=>{
            digitalEasterEgg();
        });
	}
    // $(window).on("orientationchange", initLandscapeModal);
});

function handleLightboxVideo() {
    let lightboxVideoButton = document.querySelector('[data-lightbox-video-button]'); 
    if (lightboxVideoButton) {
        lightboxVideoButton.addEventListener('click', (e) => {
            let lightbox = document.querySelector('[data-lightbox-video]');
            lightbox.classList.toggle('lightbox-hidden');
            lightbox.querySelector('video').play();
        });
        let lightboxClose = document.querySelector('[data-lightbox-video-close]');
        lightboxClose.addEventListener('click', (e) => {
            let lightbox = document.querySelector('[data-lightbox-video]');
            lightbox.classList.toggle('lightbox-hidden');
            lightbox.querySelector('video').pause();
        });
    }
}


//turned off for now
function initLandscapeModal() {
    //detect landscape orientation
    if (window.orientation == 90 || window.orientation == -90) {
        //if video is fullscreen
        if (!document.fullScreen || !document.mozFullScreen || !document.webkitIsFullScreen ) {
            // console.log(window.location.pathname);
            //create modal and append to document til they click off of it
            $("body").append(
                $(`
                <div class="landscape-orientation modal-overlay">
                    <div class="modal-inner">
                        <div class="close-modal">
                            <p>Close</p>
                            <img src="/wp-content/themes/ferg-framework/assets/images/close-icon.png" alt="close icon">
                        </div>
                        <div class="modal-box">
                            <img src="/wp-content/themes/ferg-framework/assets/images/ferg_logo.svg" alt="ferg logo">
                            <p class="message"><span class="bold">Hey there!</span><br> We recommend viewing the Ferg site in portrait mode on mobile. Thanks for visiting!</p>
                        </div>
                    </div>
                </div>
                `)
            );
            $("body").addClass("blockScroll");
            $("body").on("click", removeLandscapeModal);
        }
    } else if (window.orientation == 0) {
        removeLandscapeModal();
    }
}

function removeLandscapeModal() {
    $("body").removeClass("blockScroll");
    $("body").off("click", removeLandscapeModal);
    $(".landscape-orientation").remove();
}

function digitalEasterEgg() {
    let selection = window.getSelection();
    if (selection == "git") {
        console.log("fire away captain!")
        // $('.digital .service-background')
        //     .append(
        //         $("<video/>")
        //             .attr("src", "/wp-content/themes/ferg-framework/assets/media/digital-department.mp4")
        //     );
        // $('.digital .page-title').css('opacity', 0);
        // let digitalVideo = $('.digital .service-background video');
        // digitalVideo.get(0).play();
        // digitalVideo.on('ended', (e)=>{
        //     $('.digital .page-title').css('opacity', 1);
        //     digitalVideo.remove();
        //     selection.empty();
        // });
    }
}

function animateHeaderLogo() {
	let departments = ['Advertising', 'Media', 'Digital', 'Social', 'Public Relations', 'Video'];
	departments.forEach(function (department) {
		$('.animated-words').append('<p class="subtitle">' + department + '</p>');
	});
	$('.animated-words .subtitle').first().addClass('active');

	// run indefinitely...for now.
	let logoTimer = window.setInterval(function () {
		let current = $('.animated-words .active').length ? $('.animated-words .active') : $('.animated-words .subtitle').first();
		let next = current.next().length ? current.next() : $('.animated-words .subtitle').first();
		current.removeClass('active');
		next.addClass('active');
	}, 2000);
}

function pauseVideo(video) {
	if (video.length) {
		video.get(0).pause();
	}
}

function playVideo(video) {
	if (video.length) {
		video.get(0).play();
	}
}

function expandPanels(panels) {
	let video = panels.find("video");
	playVideo(video);
	panels.addClass("expanded");
	panels.find(".content-section").slideDown(300);
	panels.find(".featured-image").addClass("fade");
	$('.panel:not(.expanded)').addClass("low-opacity");
}

function closePanels(panels) {
	let video = panels.find("video");
	pauseVideo(video);
	panels.removeClass("expanded");
	panels.find(".content-section").slideUp(300);
	panels.find(".featured-image").removeClass("fade");
	setOpacityFilters();
}

function sortFilters(filter = "all") {
    let el = $(".filter-nav-item.selected");
    //sort first by last name to clean any other searches
    //sort second by filter
    $('.team-grid .panel').addClass('sorting');
    
    setTimeout(() => {
        $('.team-grid').prepend(function() {
            var elements = [].slice.call(this.querySelectorAll('.panel'), 0);
            //by last name alphabetically
            elements.sort(function(a, b) {
                let aName = a.getAttribute("data-name").split(" "); 
                let bName = b.getAttribute("data-name").split(" "); 
                //for YOU, David and Jaala..
                let sort;
                if (aName[1] == bName[1]) {
                    sort = aName[0] > bName[0];
                } else {
                    sort = aName[1] > bName[1];
                }
                return sort ? 1 : -1;
            });
            //by filter
            elements.sort(function(a, b) {
                return (a.className.indexOf(filter) === -1) - (b.className.indexOf(filter) === -1)
            });
            
        return elements;
        });
        $(".team-grid .panel").removeClass('sorting');
    }, 500);

}

function setOpacityFilters(filter = null) {
    if (!filter) {
        filter = $(".filter-nav-item.selected").attr("data-filter");
    }
    let el = $(".filter-nav-item.selected");
    $(".panel." + filter).removeClass("low-opacity").addClass("filtered");
    $(".panel:not(." + filter + ")").addClass("low-opacity").removeClass("filtered");
}

function triggerTeamFilter(filter) {
    $(".filter-nav-item.selected").removeClass("selected");
    $(".filter-nav-item[data-filter=" + filter + "]").addClass("selected");
    $('.mobile-filter option[value=' + filter + ']').attr("selected", "true");
    closePanels($(".panel.expanded.low-opacity"));
    sortFilters(filter);
    setOpacityFilters(filter);
}

function handleBlogAjax() {
    let paged = 0;
	$(".load-more-bar").click(function () {
        $.get("/wp-json/ferg/load-blog-post?paged=" + paged, function (data) {
            if (data != null) {
                var $new = $(data);
				$new.hide();
				$new.appendTo(".blog-grid");
				$new.slideDown();
				paged++;
			}
		});
	});
}

console.log('%cHey - what are you looking for? A job? Email us: careers@theferg.com.', consoleStyles);

let debouncedScrollHandler = debounce(function(){
	let isScrollUp = (window.scrollY - lastScrollPos < 0);
	let isScrollDown = (window.scrollY - lastScrollPos > 0);
	if (isScrollUp || isScrollDown)
	{
		if (logoState == LOGO_STATES.NORMAL)
		{
			$('.menu-button.ferguson-logo .logo-container').addClass('logoIsFlipped');
			logoState = LOGO_STATES.MENU;
		} else if (logoState == LOGO_STATES.MENU && window.scrollY == 0)
		{
			$('.menu-button.ferguson-logo .logo-container').removeClass('logoIsFlipped');
			logoState = LOGO_STATES.NORMAL;
		}
	}

	lastScrollPos = window.scrollY;
}, 10, false);

function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};


function checkBetweenDates({start, end}) {
    return Date.now() >= Date.parse(start) && Date.now() <= Date.parse(end); 
}
